module.exports = __webpack_public_path__ + "img/onboarding1.925cac52.png";